import { z } from "zod";

export const feedbackFormSchema = z.object({
  type: z.enum(["issue", "idea"]),
  description: z.string().min(1, "Description is required")
});

export type FeedbackFormValues = z.infer<typeof feedbackFormSchema>;
